import AggregateMixin from "csi/action/AggregateMixin";
import Controller from "csi/action/Controller";
import { ButtonEnum } from "designSystem/types/button-types";
import locale from "csi/locale";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import declare from "dojo/_base/declare";
import comm from "csi/comm";
import xml from "csi/xml";
import csi from "csi/main";

const {
	BUTTON_SAVE,
	BUTTON_SAVE_NEW,
} = ButtonEnum;

const NewBOMLineItem = declare([Controller, ActionControllerMixin, AggregateMixin], {

	/** @property {String} successMsg - Dynamic success message for different action types */
	successMsg: "",

	/**
	 * @override
	 *
	 * Add wizard buttons to wizard view
	 */
	addProxyActions(defView, defActions) {
		defActions.addAction(this.getProxyAction(BUTTON_SAVE_NEW, true, { m_bRepeat: true }));
		defActions.addAction(this.getProxyAction(BUTTON_SAVE, false, {}));
		this.inherited(arguments);
	},

	/**
	 * @override
	 *
	 * Refresh table
	 */
	postProcessSuccess() {
		this.widget.refreshWidget();
		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Use return value as parameter to success message based on action type
	 */
	getStringParameters() {
		const fd = this.m_formData;
		const nodes = fd.getSelectedNodes();
		return (nodes?.length) ? [`${nodes.length} ${locale.typePlural("BOMLineItem")}`] : [locale.type("BOMLineItem")];
	},

	/**
	 * @override
	 * Force back to first page
	 */
	onPrevPage: function(wizard, currentPage, prevPage) {
		if (wizard.getIndexOfPage(prevPage) > 0) {
			return wizard.skipToPrevPage(prevPage);
		}

		this.m_formData.resetSelections(); // Reset selections made on selection table
		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Disable Next button after first page
	 */
	disableNext: function(wizard, page, index) {
		return index > 0 ? true : this.inherited(arguments);
	},

	/**
	 * @override
	 *
	 * Stub out since Aggregate action handles selected nodes differently
	 */
	toWriterSelections(fd, call, id) {
		// Also done in AggregateBaseController.js
	},

	/**
	 * Helper method used by derived classes to set Parameters and Validation logic for
	 * server request of New Line Item action
	 */
	setNewOperationRequest(action, request, itemProductTypeEnum) {
		// Create url for new BOMLineItem
		this.m_urlNode = comm.createUrl();

		request = Controller.prototype.toWriter.call(this);

		// add parameters to align with New action requests
		request.addParameter(xml.PROP_TYPE, xml.ATTR_STRING, action.m_typeNode);
		request.addParameter(xml.PROP_URL_BEFORE, xml.ATTR_REF, csi.EMPTY_URL);
		request.addParameter("ItemProductType", xml.ATTR_ENUM, itemProductTypeEnum);

		// Validate newly created node
		if (this.m_writer.isChanged()) {
			this.validateNode(this.m_urlNode, true);
		}

		return request;
	},

});

export = NewBOMLineItem;